"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Filter1: ['filter-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.2,2.054a.751.751,0,0,0-.748-.8H1.5a.75.75,0,0,0-.748.8,11.254,11.254,0,0,0,8.972,10.22v9.875a.75.75,0,0,0,1.23.576l3-2.5a.748.748,0,0,0,.27-.576V12.274A11.253,11.253,0,0,0,23.2,2.054Z']],
  Filter2: ['filter-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.7,11.8v10.7c0,0.4,0.3,0.7,0.7,0.8c0,0,0,0,0,0h3c0.4,0,0.8-0.3,0.8-0.8V11.8c4.9-1,8.6-5.2,9-10.2\tc0-0.4-0.3-0.8-0.7-0.8c0,0,0,0,0,0h-21c-0.4,0-0.7,0.3-0.7,0.8c0,0,0,0,0,0C1.1,6.6,4.8,10.8,9.7,11.8z']],
  FilterText: ['filter-text', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.247,5.25h7.5a1.5,1.5,0,0,1,1.5,1.5v15a1.5,1.5,0,0,1-1.5,1.5H8.247a1.5,1.5,0,0,1-1.5-1.5v-6', 'M12.747 9.75L20.25 9.75', 'M10.497 14.25L20.25 14.25', 'M10.5 18.75L20.25 18.75', 'M8.25,9.75v-3l4.189-4.189A1.061,1.061,0,0,0,11.689.75H1.811a1.061,1.061,0,0,0-.75,1.811L5.25,6.75v6Z']],
  Filter: ['filter', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 5.250 A9.75 4.5 0 1 0 21.750 5.250 A9.75 4.5 0 1 0 2.250 5.250 Z', 'M2.25,5.25a9.747,9.747,0,0,0,7.5,9.479V21a2.25,2.25,0,0,0,4.5,0V14.729a9.747,9.747,0,0,0,7.5-9.479']]
};
exports["default"] = _default;